import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 5rem 0;
  background-color: ${props => props.theme.colors.primary.lighter};
`;

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const AboutContent = styled.div``;

const SectionTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.h2};
  margin-bottom: 2rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 0;
    width: 60px;
    height: 4px;
    background-color: ${props => props.theme.colors.accent.teal};
  }
`;

const AboutText = styled.p`
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.text.secondary};
  line-height: 1.8;
`;

const AboutAttributes = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 2rem;
`;

const Attribute = styled.div`
  display: flex;
  align-items: center;
`;

const AttributeIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.accent.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: white;
  font-size: 1.2rem;
`;

const AttributeText = styled.span`
  font-weight: 500;
`;

const About = () => {
  return (
    <AboutSection id="about">
      <AboutContainer>
        <AboutContent>
          <SectionTitle>About Me</SectionTitle>
          <AboutText>
            I am a professional, hard-working and detail-oriented network engineer. I love the challenge of setting up new networks or just making sure they work as they should. I love being thrown in the deep end and figuring out the solution needed for that problem.
          </AboutText>
          <AboutText>
            I also love dealing with people and explaining to them (without the jargon) the issues, and the steps I'll be taking to fix them. I enjoy making things simpler for everyone so their lives run more smoothly.
          </AboutText>
          <AboutText>
            I have loved working with technology since high school (when I hacked my Year 9 laptop!) I keep my skills updated as necessary as it's such a constantly changing industry. I'm excited by any new "tech" that comes out. In my spare time, I enjoy mountain bike riding, going to the gym, and hanging out with my friends.
          </AboutText>
        </AboutContent>
        <AboutAttributes>
          <Attribute>
            <AttributeIcon>🔧</AttributeIcon>
            <AttributeText>Problem Solver</AttributeText>
          </Attribute>
          <Attribute>
            <AttributeIcon>🌐</AttributeIcon>
            <AttributeText>Network Specialist</AttributeText>
          </Attribute>
          <Attribute>
            <AttributeIcon>☁️</AttributeIcon>
            <AttributeText>Cloud Engineer</AttributeText>
          </Attribute>
          <Attribute>
            <AttributeIcon>👥</AttributeIcon>
            <AttributeText>People-Focused</AttributeText>
          </Attribute>
          <Attribute>
            <AttributeIcon>🔒</AttributeIcon>
            <AttributeText>Security Conscious</AttributeText>
          </Attribute>
          <Attribute>
            <AttributeIcon>📚</AttributeIcon>
            <AttributeText>Continuous Learner</AttributeText>
          </Attribute>
        </AboutAttributes>
      </AboutContainer>
    </AboutSection>
  );
};

export default About;
